import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'

const StatusFilter = ({ menuOption, handleStatusChange, checkStatus }) => {
  return (
    <FilterCheckBoxComp
      options={menuOption}
      value={checkStatus}
      onChange={handleStatusChange}
    />
  )
}

export default StatusFilter
